import { useState } from "react";
import { Star } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";

// Shown when someone finishes cook mode on another cook's recipe.
export default function CookRatingPrompt({ recipe, onDone }) {
  const [hover, setHover] = useState(0);
  const [busy, setBusy] = useState(false);
  const rate = async (n) => {
    setBusy(true);
    try {
      await api.post(`/recipes/${recipe.recipe_id}/rate`, { stars: n });
      toast.success("Thanks for rating! It helps other cooks find great recipes.");
    } catch { toast.error("Couldn't save your rating"); }
    onDone();
  };
  return (
    <div className="fixed inset-0 z-[120] bg-rf-ink/80 flex items-center justify-center p-4" onClick={(e) => e.stopPropagation()} data-testid="cook-rating-prompt">
      <div className="w-full max-w-sm rounded-3xl bg-rf-cream text-rf-ink p-7 text-center shadow-2xl">
        <p className="overline mb-2">You did it</p>
        <h2 className="font-display font-black text-2xl mb-1">How was {recipe.title}?</h2>
        <p className="text-sm text-rf-ink-soft mb-5">Tap the stars. It only takes a second.</p>
        <div className="flex justify-center gap-1.5 mb-6" onMouseLeave={() => setHover(0)}>
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" disabled={busy} onMouseEnter={() => setHover(n)} onClick={() => rate(n)}
                    aria-label={`${n} star${n === 1 ? "" : "s"}`} data-testid={`cook-rating-star-${n}`}
                    className="p-1 transition-transform hover:scale-110 disabled:opacity-60">
              <Star size={40} weight={n <= hover ? "fill" : "regular"} className={n <= hover ? "text-rf-orange" : "text-rf-ink/30"} />
            </button>
          ))}
        </div>
        <button type="button" onClick={onDone} data-testid="cook-rating-skip" className="text-sm font-bold text-rf-ink-soft hover:text-rf-ink underline underline-offset-2">
          Maybe later
        </button>
      </div>
    </div>
  );
}
